import React from 'react';
import {connect} from 'react-redux';
import Week from '../../common/Calendar/Week';
import {Row, Col, OverlayTrigger, Tooltip} from 'react-bootstrap';
import * as commonActions from '../../../actions/commonActions';
import * as utils from '../../../utils/utils';

class SchedulesView extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      currentSchedule: {},
      scheduleIndex: 0
    }
    this.previousSchedule = this.previousSchedule.bind(this);
    this.nextSchedule = this.nextSchedule.bind(this);
    this.isFavoriteClass = this.isFavoriteClass.bind(this);
  }

  componentWillMount() {
    this.setState({currentSchedule: this.props.schedules[0], scheduleIndex: 0});
  }

  componentDidUpdate(prevProps) {
    if (prevProps.schedules !== this.props.schedules) {
      this.setState({
        currentSchedule: this.props.schedules[this.state.scheduleIndex]
      })
    }
  }

  previousSchedule() {
    let scIndex = this.state.scheduleIndex - 1;
    if (scIndex < 1) {
      this.setState({currentSchedule: this.props.schedules[0], scheduleIndex: 0});
    } else {
      this.setState({currentSchedule: this.props.schedules[scIndex], scheduleIndex: scIndex});
    }
  }

  nextSchedule() {
    let scIndex = this.state.scheduleIndex + 1;
    if (scIndex >= this.props.schedules.length) {
      this.setState({
        currentSchedule: this.props.schedules[this.props.schedules.length - 1],
        scheduleIndex: this.props.schedules.length - 1
      });
    } else {
      this.setState({currentSchedule: this.props.schedules[scIndex], scheduleIndex: scIndex});
    }
  }

  isFavoriteClass(courseId) {
    let favorite = false;
    this.props.student.preferences.map(pref => {
      if(pref.preference_class == 0 && pref.course == courseId) {
        favorite = true;
      }
    });
    return favorite;
  }

  render() {
    const { schedules, courses } = this.props;
    const classTooltip = (c) => {
      return <Tooltip id="tooltip1">
        <div className="eventTooltipLine"><span className="text-bold">{c.longname}</span></div>
        <div className="eventTooltipLine"><span className="text-bold">{c.instructor}</span></div>

        {commonActions.getCourseLocations(c).map((l,i) => {
          return <div key={i} className="location-row">
            <div className="text-bold">Location: {l.location}</div>
            <div><span>{l.days.map((m,j) => {
              return <span key={j}>{utils.convertDayShort(m)},</span>
            })} {l.startTime.substring(0,5)} - {l.endTime.substring(0,5)}</span></div>
            <div>{l.startDate} - {l.endDate}</div>
          </div>
        })}
      </Tooltip>
    }
    return (
      <Row>
        <Col md={12}>
          <div >
            {schedules.length > 1 ?
              <Row>
                <Col md={12}>
                  <div className="schedule-navigation">
                    <h2>Tied with {schedules.length - 1} other schedules</h2>
                    <i
                      onClick={() => {this.previousSchedule()}}
                      className="fa fa-arrow-left mr-2"
                      style={{
                        color: this.state.scheduleIndex != 0 ? '#9A77B5' : '#B1B3B4'
                      }}
                    ></i>
                    <span className="tie-schedule-no">{this.state.scheduleIndex + 1}</span>
                    <i onClick={() => {
                      this.nextSchedule()
                    }} className="fa fa-arrow-right ml-2"
                       style={{
                         color: this.state.scheduleIndex < schedules.length - 1 ? '#9A77B5' : '#B1B3B4'
                       }}
                    ></i>
                  </div>
                </Col>
              </Row>
              : null}
            <Week
              days={this.state.currentSchedule}
              isFavoriteClass={this.isFavoriteClass}
              courses={courses}
            />
            {this.state.currentSchedule.noMeetings.length != 0 ?
              <div className="schedulesNoMeetings other-courses mb-2">
                <h2>OTHER CLASSES:</h2>
                {this.state.currentSchedule.noMeetings.map((c, i) => {
                    return <OverlayTrigger key={i} placement="top" overlay={classTooltip(c)}>
                      <div className={`other-course  ${this.isFavoriteClass(c.id) ? 'favorite' : ''}`}>
                        {c.external_url ? <a href={c.external_url} target="_blank">{c.slug}</a> : c.slug}
                      </div>
                    </OverlayTrigger>
                })}
              </div>
              : null}
          </div>
        </Col>
      </Row>
    );
  }
}
function mapStateToProps(state) {
  return {
    courses: state.courses,
    student: state.student
  }
}
export default connect(mapStateToProps)(SchedulesView);




// WEBPACK FOOTER //
// ./src/components/rank/ScheduleViewAddDrop/SchedulesView.js